import React from 'react';
import UQIcon from '../icon';
import './style.scss';

export interface UQLoaderProps {
  animation?: 'spin' | 'clip' | 'spin-rainbow' | 'clip-rainbow' | 'cube' | 'cube-rainbow' | 'cube-rainbow-static'; 
  size?: 's' | 'm' | 'l' | 'xl';
  color?: 'blue' | 'turquois' | 'mint' | 'green' | 'yellow' | 'peach' | 'salmon' | 'purple'; 
}

const UQLoader: React.FC<UQLoaderProps> = ({ size = 'm', color = 'blue', animation = 'spin'}) => {
  let animationClass = '';
  let loaderClass = 'spin-loader';
  
  if (animation === 'clip') animationClass = 'with-clip-animation';
  if (animation === 'spin-rainbow') animationClass = 'rainbow-spin';
  if (animation === 'clip-rainbow') animationClass = 'with-clip-animation rainbow-clip';
  if (animation === 'cube') {
    loaderClass = 'cube-loader';
    animationClass = '';
  }
  if (animation === 'cube-rainbow') {
    loaderClass = 'cube-loader';
    animationClass = 'rainbow-cube';
  }
  if (animation === 'cube-rainbow-static') {
    loaderClass = 'cube-loader';
    animationClass = 'rainbow-cube-static';
  }

  if (animation === 'cube' || animation === 'cube-rainbow' || animation === 'cube-rainbow-static') {
    const colorClass = animation === 'cube' ? '' : `loader-${color}`;
    return (
      <div className={`${loaderClass} loader-${size} ${colorClass} ${animationClass}`.trim()}>
        <UQIcon icon="logo-cube" />
      </div>
    );
  }

  return (
    <div
      className={`${loaderClass} loader-${size} loader-${color} ${animationClass}`}
    />
  );
};

export default UQLoader;
